<template>
  <div
    v-if="intent"
    class="intent-item pa-0 mb-3"
    :style="{
      border: `1px solid ${$vuetify.theme.primary}`,
      'border-left': intentStatus.isOnline ? `5px solid #a0e83d` : `5px solid red`
    }"
    :class="{ edit: isEdit }"
  >
    <v-layout v-if="!isEdit" wrap @click="toggleDetail">
      <v-flex xs12 sm8>
        <template v-if="!isEdit">
          <div class="text-truncate pa-2">
            <template v-if="!hideStatus">
              <toggle-button
                v-if="!livechat && !isBeacon"
                :value="intent.intentstatus"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="onChangeIntentStatus"
              />
              <toggle-button
                v-if="isBeacon"
                :value="intent.status"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="onChangeIntentStatus"
              />
            </template>
            <template v-if="isBeacon">
              {{ intentLabel(intent.campaign_name) }}
              <div class="pt-2">
                <span class="primary--text pr-2">{{ $t('beacon_type') }}:</span
                ><span>{{ beaconType }}</span>
              </div>
            </template>
            <template v-else-if="intent.intentname == '{first_announcement_message}'">
              {{ $t('first_announcement') }}
            </template>
            <template v-else>
              {{ intentLabel(intent.intentname) }}
            </template>
          </div>
          <template v-if="showMultipleChannel">
            <AvailableMultipleChannel
              class="ml-2"
              :messages="{
                fb_answers,
                line_answers,
                ig_answers,
                ms_team_answers,
                whatsapp_answers
              }"
            />
          </template>
        </template>
      </v-flex>

      <v-flex xs12 sm4 class="text-xs-right pa-1">
        <div style="display: inline-block" @click.stop>
          <v-btn
            v-if="hasSocialConnected && isRefLinkEnabled"
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="$emit('viewRefLink', value)"
          >
            <v-icon>link</v-icon>
          </v-btn>
          <template v-if="isCommentToInbox && !isLiveStream">
            <v-chip label outline small disabled color="info">
              <IntentSelectPostLabel v-model="postidlist"></IntentSelectPostLabel>
            </v-chip>

            <div class="clearfix" style="margin-bottom: 10px"></div>
          </template>
          <template v-if="selectedBot.theme == 'universalutilities' && !livechat">
            <template
              v-if="intent.intentgroup == selectedBot.uu_areaname || !selectedBot.uu_areaname"
            >
              <v-btn
                v-if="!isEdit"
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                @click="isEdit = true"
              >
                <em class="fas fa-pencil-alt" />
              </v-btn>
              <v-btn
                v-if="
                  !isEdit &&
                  intent.intentname != '{default}' &&
                  intent.intentname != '{default_comment_to_inbox}' &&
                  !hideCopy
                "
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                @click="onCopyMyIntent()"
              >
                <em class="fa fa-copy middle" />
              </v-btn>

              <v-btn
                v-if="
                  !isEdit &&
                  intent.intentname != '{default}' &&
                  intent.intentname != '{default_comment_to_inbox}' &&
                  !hideDelete
                "
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                @click="$emit('onDelete')"
              >
                <em class="fa fa-trash middle" />
              </v-btn>
            </template>
          </template>
          <template v-else-if="!livechat">
            <template
              v-if="
                ['{default_comment_to_inbox}'].includes(intent.intentname) &&
                $store.getters.getPackage != 'premium' &&
                selectedBot.pagetype != 'enterprise'
              "
            >
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn class="extra-small ma-1" readonly fab outline small color="grey" v-on="on">
                    <v-icon>lock</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Upgrade to Premium Plan') }}</span>
              </v-tooltip>
            </template>
            <template v-else>
              <v-btn
                v-if="!isEdit"
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                @click="editIntent"
              >
                <em class="fas fa-pencil-alt" />
              </v-btn>
            </template>

            <v-btn
              v-if="
                !isEdit &&
                intent.intentname != '{default}' &&
                !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname) &&
                !hideCopy
              "
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              @click="onCopyMyIntent()"
            >
              <em class="fa fa-copy middle" />
            </v-btn>
            <v-btn
              v-if="
                !isEdit &&
                intent.intentname != '{default}' &&
                !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname) &&
                !hideDelete
              "
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              @click="$emit('onDelete')"
            >
              <em class="fa fa-trash middle" />
            </v-btn>
          </template>
          <template v-else-if="livechat">
            <v-btn depressed color="primary" @click="isEdit = true">{{ $t('Edit/Send') }}</v-btn>

            <v-btn
              v-if="
                ticket2showdelete &&
                !isEdit &&
                intent.intentname != '{default}' &&
                !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname) &&
                !hideDelete
              "
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              @click="$emit('onDelete')"
            >
              <em class="fa fa-trash middle" />
            </v-btn>
            <v-btn v-if="kfcpagemustedit" depressed color="primary" @click="sendToLivechat(intent)"
              >{{ $t('Send') }}
            </v-btn>
          </template>
        </div>
      </v-flex>

      <v-flex xs10 class="pa-1">
        <v-chip
          v-if="
            $store.state.linenotifylist.length > 0 &&
            ((intent.linenoti_status && selectedBot.notify_intent && !isCommentToInbox) ||
              (intent.linenoti_status && selectedBot.notify_comment && isCommentToInbox))
          "
          small
          color="#00c300"
          text-color="white"
          disabled
        >
          <v-avatar>
            <em class="fas fa-bell" />
          </v-avatar>
          {{ $t('Line Notify') }}
        </v-chip>
        <div v-if="intent.onlytime === null">
          <template v-for="(item, index) in timeSetting">
            <v-tooltip :key="`item-time-${index}`" top>
              <template #activator="{ on, attrs }">
                <v-chip
                  small
                  :color="
                    item.isToday && item.isActive
                      ? '#a0e83d'
                      : item.isToday && !item.isActive
                      ? 'red'
                      : ''
                  "
                  text-color="white"
                  :disabled="!item.isToday"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.day }}
                </v-chip>
              </template>
              <span>{{ item.status ? item.timeLength : $t('Not activated') }}</span>
            </v-tooltip>
          </template>
        </div>
        <v-chip
          v-if="intent.starttime"
          small
          :color="intentStatus.isStarttime ? '#a0e83d' : 'red'"
          text-color="white"
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          <template v-if="intent.starttime">
            Start
            <template v-if="intent.onlytime && !isFirstAnnouncement">{{
              intent.starttime | DateFormat('HH:mm')
            }}</template>
            <template v-else>{{ intent.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
          </template>
        </v-chip>
        <v-chip
          v-if="intent.endtime"
          small
          :color="intentStatus.isEndtime ? '#a0e83d' : 'red'"
          text-color="white"
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          <template v-if="intent.endtime">
            End
            <template v-if="intent.onlytime && !isFirstAnnouncement">{{
              intent.endtime | DateFormat('HH:mm')
            }}</template>
            <template v-else>{{ intent.endtime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
          </template>
        </v-chip>
      </v-flex>
      <v-flex xs2 class="text-xs-right pa-1">
        <template v-if="!isEdit">
          <div>
            <span
              class="fas"
              :style="`font-size: 1.5em;margin-right: 5px; cursor: pointer; color: ${$vuetify.theme.primary}`"
              :class="{ 'fa-chevron-down': !showDetail, 'fa-chevron-up': showDetail }"
            ></span>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="isEdit || showDetail">
      <template v-if="isEdit">
        <manage-intent
          v-if="!isBeacon"
          v-model="intent"
          :type="'edit'"
          :livechat="livechat"
          :is-live-stream="isLiveStream"
          :is-comment-to-inbox="isCommentToInbox"
          :is-default="
            intent.intentname == '{default}' ||
            [
              '{default_comment_to_inbox}',
              '{default_live}',
              '{first_announcement_message}'
            ].includes(intent.intentname)
          "
          :hide-question="hideQuestion"
          :hide-advance-options="hideAdvanceOptions"
          :hide-setting="hideSetting"
          :hide-priority="hidePriority"
          :hide-choice="hideChoice"
          :readonly-name="readonlyName"
          :excluded-intent-name="excludedIntentName"
          :available-bubbles="availableBubbles"
          :hide-status="hideStatus"
          @sendtolivechat="sendToLivechat"
          @close="onClose"
          @saveIntent="onSave"
        ></manage-intent>
        <manage-intent
          v-else
          v-model="intent"
          :is-intent="isIntent"
          :type="'edit'"
          :is-comment-to-inbox="false"
          :excluded-intent-name="excludedIntentName"
          :is-beacon="isBeacon"
          :hide-choice="hideChoice"
          @close="onClose"
          @saveIntent="onSave"
        ></manage-intent>
      </template>
      <template v-else>
        <v-divider></v-divider>
        <v-layout wrap justify-end>
          <div v-if="!hidePriority">
            <v-checkbox
              v-model="intent.ispriority"
              class="mt-1 mb-1 pr-2"
              disabled
              hide-details
              :label="$t('First Priority')"
            ></v-checkbox>
          </div>
        </v-layout>
        <v-layout wrap>
          <v-flex v-if="!livechat" xs12 sm6>
            <div class="question pa-2">
              <template
                v-if="
                  ['{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                    intent.intentname
                  ) || hideQuestion
                "
              ></template>
              <template v-else-if="dataVerifySlip && dataVerifySlip.length > 0">
                <h1 class="mt-2 mb-1" style="color: #000">
                  {{ $t('payment_method') }}
                  <span v-if="isMetaVerifySlip">Basic Slip Verification</span>
                </h1>

                <div
                  v-for="(item, index) in dataVerifySlip"
                  :key="index"
                  class="form-control intent-item z-border-red pa-3"
                >
                  <div
                    v-if="item.status && item.status === 'pending'"
                    style="text-align: right; color: #fb8c00"
                  >
                    <small class="mr-2">ยังไม่ได้ยืนยันบัญชีบน META Business Suite</small>
                    <i
                      v-tooltip.top="$t('verify_on_meta')"
                      class="fas fa-info-circle"
                      style="font-size: 20px; vertical-align: middle"
                    ></i>
                  </div>
                  <i
                    v-if="item.status && item.status === 'verified'"
                    v-tooltip.top="$t('Verified by Meta')"
                    class="fas fa-check-circle green--text"
                    style="float: right; font-size: 20px"
                  ></i>

                  <template v-if="item.typeAccount && item.typeAccount.value === 'all'">
                    <div class="primary--text">
                      {{ $t('bank_name') }} : <span> {{ $t('not_specified_account') }} </span>
                    </div>
                  </template>
                  <template v-else>
                    <v-layout wrap>
                      <v-flex xs2>
                        <img
                          v-if="item.bankName && item.bankName === 'promptpay'"
                          style="width: 40px"
                          :src="'/static/img/assets/payment/logo_e_wallet/ewallet.png'"
                        />
                        <img
                          v-else
                          style="width: 40px"
                          :src="
                            getBankName(item.bankName)
                              ? getBankName(item.bankName).image
                              : '/static/img/assets/_global/default-photo.png'
                          "
                        />
                      </v-flex>
                      <v-flex xs10>
                        <div>
                          <h4 v-if="item.bankName && item.bankName === 'promptpay'">
                            {{ $t('promptpay') }}
                          </h4>
                          <div v-else class="primary--text">
                            {{ $t('bank_name') }} :
                            <span v-if="getBankName(item.bankName)">{{
                              getBankName(item.bankName).name_th
                            }}</span>
                          </div>
                        </div>
                        <div style="font-size: 90%">
                          <div>
                            <span v-if="item.bankName && item.bankName === 'transfer'">
                              {{ $t('bank_account') }} :
                            </span>
                            <span v-else-if="item.bankName && item.bankName === 'promptpay'">
                              {{ $t('promptpay_code') }} :</span
                            >
                            <span
                              v-else-if="item.typeAccount && item.typeAccount.value === 'eWallet'"
                            >
                              {{ $t('E-Wallet ID') }}
                            </span>
                            <span
                              v-else-if="
                                item.typeAccount && item.typeAccount.value === 'paymentGateway'
                              "
                            >
                              {{ $t('Biller ID') }}
                            </span>
                            <span v-else> {{ $t('bank_account_no') }} :</span>
                            <span
                              ><template v-if="isMetaVerifySlip">xxxxxx</template
                              >{{ item.bankAccountNo }}</span
                            >
                          </div>
                          <div>
                            <span> {{ $t('receiver_name') }} :</span>
                            <span v-if="isMetaVerifySlip"> {{ item.name }} </span>
                            <template v-else>
                              <template v-if="item.keyword && item.keyword.length > 0">
                                <span
                                  v-for="(val, index) in item.keyword"
                                  :key="`name_text_${index}`"
                                >
                                  {{ val.text }}
                                  <span v-if="index !== item.keyword.length - 1">,</span></span
                                >
                              </template>
                              <span v-else> -</span>
                            </template>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </template>
                </div>
                <div v-if="isMetaVerifySlip" style="text-align: right">
                  <v-btn
                    outline
                    color="primary"
                    @click="
                      openLink(
                        `https://business.facebook.com/latest/orders/payment_settings?asset_id=${selectedBot.pageid}&nav_ref=add_accounts_slip_verification`
                      )
                    "
                    >{{ $t('confirm_account') }}</v-btn
                  >
                </div>
              </template>
              <template v-else>
                <p>{{ isBeacon ? 'รูปแบบการส่ง' : $t('customer says') }}</p>
                <template v-if="normal && normal.length > 0">
                  <label class="caption">{{ $t('Sentence') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <!-- :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`" -->
                    <li
                      v-for="(question, index) in normal"
                      :key="'normal_question_' + index"
                      class="tag"
                      :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="keyword && keyword.length > 0">
                  <label class="caption">{{ $t('Keyword') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      v-for="(question, index) in keyword"
                      :key="'keyword_question_' + index"
                      class="tag"
                      :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="exactly && exactly.length > 0">
                  <label v-if="!isBeacon" class="caption">{{ $t('Exact word') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      v-for="(question, index) in exactly"
                      :key="'exactly_question_' + index"
                      class="tag"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="isBeacon">
                  <p>ชื่อ Beacon ที่ตอบ</p>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li v-for="(item, index) in specificBeaconIds" :key="index" class="tag">
                      <specialtext :text="item"></specialtext>
                    </li>
                  </ul>
                </template>
                <template
                  v-if="startwith && startwith.length > 0 && $store.getters.getPackage == 'premium'"
                >
                  <label class="caption">{{ $t('Start with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      v-for="(question, index) in startwith"
                      :key="'startwith_question_' + index"
                      class="tag"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="endwith && endwith.length > 0 && $store.getters.getPackage == 'premium'"
                >
                  <label class="caption">{{ $t('End with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      v-for="(question, index) in endwith"
                      :key="'endwith_question_' + index"
                      class="tag"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="
                    startandendwith &&
                    startandendwith.length > 0 &&
                    $store.getters.getPackage == 'premium'
                  "
                >
                  <label class="caption">{{ $t('Start and End with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      v-for="(question, index) in startandendwith"
                      :key="'startandendwith_question_' + index"
                      class="tag"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>

                <label v-show="isOtherLang && $store.getters.getPackage != 'premium'">
                  <em class="fas fa-exclamation-circle" />
                  {{
                    $t(
                      'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
                    )
                  }}
                </label>
              </template>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <template v-if="value.q_val.startsWith('{verify_slip.bank_info=')">
              <IntentSlipVerificationPreview
                :show-multiple-channel="showMultipleChannel"
                :intent="intent"
                :is-comment-to-inbox="isCommentToInbox"
                :hide-choice="hideChoice"
                :replies="replies"
              />
            </template>
            <template
              v-else-if="answers || fb_answers || line_answers || ig_answers || ms_team_answers"
            >
              <PreviewConversation
                class="pa-2"
                :show-multiple-channel="showMultipleChannel"
                :intent="intent"
                :answers="answers"
                :tab="tab"
                :multi-messages="{
                  fb_answers,
                  line_answers,
                  ig_answers,
                  ms_team_answers,
                  whatsapp_answers,
                  app_answers,
                  webchat_answers
                }"
                :is-comment-to-inbox="isCommentToInbox"
                :hide-choice="hideChoice"
                :replies="replies"
                @handleChangeTab="tab = $event"
              />
            </template>
            <template v-if="isBeacon">
              <PreviewBeaconConversation
                class="pa-2"
                :intent="intent"
                :tab="tab"
                @handleChangeTab="tab = $event"
              />
            </template>
          </v-flex>
        </v-layout>
        <div v-if="selectedBot && selectedBot.type === 'hopinnhr'" class="my-3">
          <v-layout wrap>
            <v-flex xs6 class="pa-2">
              <div class="caption">ตำแหน่ง</div>
              <div>{{ intent.custom_filter_2 ? intent.custom_filter_2 : 'All' }}</div>
            </v-flex>
            <v-flex xs6 class="pa-2">
              <div class="caption">สังกัด</div>
              <div>{{ intent.custom_filter_1 ? intent.custom_filter_1 : 'All' }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="isJuzmatchSale || isJuzmatchCrm" class="my-3">
          <v-layout wrap>
            <v-flex xs6 class="pa-2">
              <div class="caption">role</div>
              <div>{{ role }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="isRoots" class="my-3">
          <v-layout wrap>
            <v-flex xs6 class="pa-2">
              <div class="caption">{{ $t('company') }}</div>
              <div class="pt-2">{{ rootsCurrentCompany }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="isGpfBuddy" class="my-3">
          <v-layout wrap>
            <v-flex xs3 class="pa-2">
              <div class="primary--text caption">{{ $t('company') }}</div>
              <div>
                {{
                  intent.gpf_company_code
                    ? handleGetTextGpfBuddyMasterData('company', intent)
                    : 'All'
                }}
              </div>
            </v-flex>
            <v-flex xs3 class="pa-2">
              <div class="primary--text caption">{{ $t('work_group') }}</div>
              <div>
                {{
                  intent.gpf_group_code ? handleGetTextGpfBuddyMasterData('group', intent) : 'All'
                }}
              </div>
            </v-flex>
            <v-flex xs3 class="pa-2">
              <div class="primary--text caption">{{ $t('department') }}</div>
              <div>
                {{
                  intent.gpf_department_code
                    ? handleGetTextGpfBuddyMasterData('department', intent)
                    : 'All'
                }}
              </div>
            </v-flex>
            <v-flex xs3 class="pa-2">
              <div class="primary--text caption">{{ $t('position') }}</div>
              <div>
                {{
                  intent.gpf_position_code
                    ? handleGetTextGpfBuddyMasterData('position', intent)
                    : 'All'
                }}
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div
          v-if="isAssetWise && intent.groups_conversation && intent.groups_conversation.length"
          class="my-3 px-2 py-1"
        >
          <div>{{ $t('asset_wise.role') }}</div>
          <AssetWiseRoleSelect
            :value="
              Array.isArray(intent.groups_conversation)
                ? intent.groups_conversation
                : JSON.parse(intent.groups_conversation)
            "
            readonly
          />
        </div>
        <div
          v-if="
            intent.userstatus ||
            (intent.linenoti_status && intent.linenoti_text && intent.linenoti_text.trim() != '') ||
            (intent.context_in && !['comment', 'facebooklive'].includes(intent.context_in)) ||
            intent.context_out ||
            (usertags && usertags.length > 0) ||
            (deleteUserTags && deleteUserTags.length > 0) ||
            intent.remaining_reply != null ||
            intent.hasOwnProperty('notreplysameperson') ||
            intent.intentgroup ||
            intent.follow_up_status ||
            intent.update_by ||
            intent.bot_profile_id ||
            intent.event_setting ||
            (intent.line_rich_menu_setting || {}).change_rich_menu_status ||
            intent.groups_conversation
          "
        >
          <v-divider></v-divider>

          <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
            <v-tab v-if="showAdvancedMenu('customer')" :key="0" :href="'#tab-0'" ripple>{{
              $t('Customer')
            }}</v-tab>
            <template v-if="intent.intentname !== '{first_announcement_message}'">
              <v-tab
                v-if="!isCommentToInbox && showAdvancedMenu('context') && !isBeacon"
                :key="1"
                :href="'#tab-1'"
                ripple
                >{{ $t('Context') }}</v-tab
              >
              <v-tab
                v-if="showAdvancedMenu('timer') && !isBeacon"
                :key="2"
                :href="'#tab-2'"
                ripple
                >{{ $t('Timer') }}</v-tab
              >
              <v-tab
                v-if="showAdvancedMenu('line_notify') && !isBeacon"
                :key="3"
                :href="'#tab-3'"
                ripple
                >{{ $t('Line Notify') }}</v-tab
              >
              <v-tab
                v-show="
                  false && isCommentToInbox && showAdvancedMenu('limit_reply_to_inbox') && !isBeacon
                "
                :key="4"
                :href="'#tab-4'"
                ripple
                >{{ $t('Limit reply to inbox') }}</v-tab
              >
              <v-tab
                v-if="showAdvancedMenu('intent_group') && showIntentGroup && !isBeacon"
                :key="5"
                :href="'#tab-5'"
                ripple
                >{{ $t('Intent Group') }}</v-tab
              >
              <v-tab v-if="isBeacon" :key="8" :href="'#tab-6'" ripple>{{ $t('frequency') }}</v-tab>
              <v-tab v-if="showAdvancedMenu('follow_up')" :key="7" href="#tab-7" ripple>{{
                $t('Follow Up')
              }}</v-tab>
              <v-tab :key="9" :href="'#tab-9'" ripple>{{ $t('History') }}</v-tab>
              <v-tab :key="10" :href="'#tab-10'" ripple>{{ $t('bot_profile') }}</v-tab>
              <v-tab
                v-if="isRichMenuEnabled && selectedBot.line_access_token && !isCommentToInbox"
                :key="11"
                :href="'#tab-11'"
                ripple
                >LINE Rich Menu</v-tab
              >
              <v-tab
                v-if="
                  !isBeacon &&
                  !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
                  isFacebookConversionConnected
                "
                :key="12"
                :href="'#tab-12'"
                ripple
                >{{ $t('purchase_event') }}</v-tab
              >
              <v-tab v-if="isSrichand" :key="'user-status'" :href="'#user-status'" ripple>{{
                $t('user_status')
              }}</v-tab>
              <v-tab
                v-if="isEventTrackingEnabled"
                :key="'event-tracking'"
                :href="'#event-tracking'"
                ripple
                >{{ $t('Event Tracking') }}</v-tab
              >
            </template>

            <v-tab-item :key="0" :value="'tab-0'">
              <v-card flat>
                <v-card-text>
                  <div>
                    <div class="caption">{{ $t('Status') }}</div>
                    <p class="primary-color">{{ intent.userstatus ? intent.userstatus : '-' }}</p>
                  </div>
                  <div class="mb-4">
                    <div class="caption">{{ $t('Add tag') }}</div>
                    <ul class="tags pt-1">
                      <li
                        v-for="(usertag, index) in usertags"
                        :key="'usertag_' + index"
                        class="tag"
                      >
                        <specialtext :text="usertag"></specialtext>
                      </li>
                    </ul>
                  </div>
                  <div class="mb-4">
                    <div class="caption">{{ $t('Remove tag') }}</div>
                    <ul class="tags pt-1">
                      <li
                        v-for="(usertag, index) in deleteUserTags"
                        :key="'usertag_' + index"
                        class="tag"
                      >
                        <specialtext :text="usertag"></specialtext>
                      </li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!isCommentToInbox" :key="1" :value="'tab-1'">
              <v-card flat>
                <v-card-text>
                  <v-layout>
                    <template v-if="!['comment', 'facebooklive'].includes(intent.context_in)">
                      <v-flex>
                        <div class="caption">Context In</div>
                        <p class="primary-color">
                          {{ intent.context_in || '-' }}
                        </p>
                      </v-flex>
                    </template>
                    <v-flex>
                      <div class="caption">Context Out</div>
                      <p class="primary-color">
                        {{ intent.context_out || '-' }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2" :value="'tab-2'">
              <v-card flat>
                <v-card-text>
                  <template v-if="intent.time_setting">
                    <IntentScheduleTable :value="toTransformedSchedule(intent)" />
                  </template>
                  <template v-else>
                    <v-layout>
                      <v-flex>
                        <div class="caption">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                        </div>
                        <div class="primary-color">
                          {{
                            intent.starttime
                              ? moment(intent.starttime).format('DD-MM-YYYY HH:mm')
                              : '-'
                          }}
                        </div>
                      </v-flex>
                      <v-flex>
                        <div class="caption">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                        </div>
                        <div class="primary-color">
                          {{
                            intent.endtime ? moment(intent.endtime).format('DD-MM-YYYY HH:mm') : '-'
                          }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="3" :value="'tab-3'">
              <v-card flat>
                <v-card-text>
                  <div class="caption">{{ $t('Line Notify') }}</div>
                  <div class="primary-color">
                    {{ intent.linenoti_text ? intent.linenoti_text : '-' }}
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="4" :value="'tab-4'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium'"
                  :show-all="false"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="col s12 form-control">
                    <div class="caption">{{ $t('Reply to comment (amount)') }}</div>
                    <p class="primary-color">
                      {{ intent.remaining_reply != null ? intent.remaining_reply : '-' }}
                    </p>

                    <div class="caption">{{ $t('Reply once/person') }}</div>
                    <p class="primary-color">
                      {{ intent.notreplysameperson ? $t('active') : $t('inactive') }}
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="5" :value="'tab-5'">
              <v-card flat>
                <v-card-text>
                  <IntentTicket3Group
                    v-if="selectedBot && selectedBot.unlock_ticket_3"
                    :intentgroup="intentgroup"
                  />
                  <IntentTicketGroup
                    v-else-if="
                      [
                        'ticket',
                        'ticket2',
                        'studio7',
                        'ustore',
                        'tdtawandang',
                        'cityfresh',
                        ...$store.state.ticketThemeList
                      ].includes(selectedBot.theme) ||
                      [...$store.state.ticketPageid, ...$store.state.toaPaintPage].includes(
                        selectedBot.pageid
                      ) ||
                      ['gpf'].includes(selectedBot.type)
                    "
                    :intentgroup="intentgroup"
                  />
                  <div v-else>
                    <div class="caption">{{ $t('Intent Group') }}</div>
                    <p class="primary-color">{{ intentgroup }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="isBeacon" :key="8" :value="'tab-6'">
              <v-card flat>
                <v-card-text>
                  <div>
                    <div class="form-control" style="display: flow-root">
                      <span> {{ $t('not_sending_message_to_the_same_person_within') }}</span>
                      <span>
                        {{ intent.not_reply_within_seconds / 60 || '-' }}
                        {{ $t('minute') }}</span
                      >
                    </div>

                    <div class="form-control mt-2" style="display: flow-root">
                      <span> {{ $t('limit_restrict_sending_to_same_person') }}</span>
                      <span> {{ intent.not_reply_within_times || '-' }} {{ $t('time') }}</span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="7" :value="'tab-7'"
              ><v-card flat>
                <v-card-text>
                  <div>
                    <h4 class="mt-3 mb-2 header" style="font-size: 15px">
                      {{ $t('this_message_within_24_hours') }}
                    </h4>
                    <h4 v-if="isCommentToInbox" class="mb-2 title">
                      {{
                        $t(
                          `If user hasn't sent message in inbox within 24 hours,The follow-up message won't be sent`
                        )
                      }}
                    </h4>
                    <p>
                      {{ $t('status') }}
                      <span v-if="intent.follow_up_status">
                        <v-icon color="green">circle</v-icon> {{ $t('open') }}</span
                      ><span v-else> <v-icon color="red">circle</v-icon> {{ $t('close') }}</span>
                    </p>
                    <p>
                      <span
                        >{{
                          Math.floor(parseInt(intent.follow_up_within_seconds) / 60 / 60) || '-'
                        }}
                        {{ $t('hour') }}</span
                      >
                      <span
                        >{{ (parseInt(intent.follow_up_within_seconds) / 60) % 60 || '-' }}
                        {{ $t('minute') }}</span
                      >
                    </p>

                    <template v-if="intent.follow_up_type == 'json'">
                      <div>
                        <v-layout>
                          <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                            <template v-if="isCommentToInbox">
                              <p class="mt-3">{{ $t('Chatbot answers') }}</p>
                              <template v-if="answersFollowUp && answersFollowUp[0].length > 0">
                                <message-viewer v-model="answersFollowUp"></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>

                            <template v-else>
                              <p>{{ $t('Chatbot answers') }}</p>
                              <template v-if="intent.a_type == 'json'">
                                <div>
                                  <template v-if="!showMultipleChannelFollowUp">
                                    <template
                                      v-if="answersFollowUp && answersFollowUp[0].length > 0"
                                    >
                                      <message-viewer
                                        v-model="answersFollowUp"
                                        :channel="tabFollowUp"
                                      ></message-viewer>
                                    </template>
                                    <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                                  </template>
                                  <template v-else>
                                    <v-layout>
                                      <v-flex
                                        class="channel"
                                        shrink
                                        style="border-right: 1px solid #eee"
                                      >
                                        <template
                                          v-for="social in conversationSocialChannelOptions"
                                        >
                                          <div
                                            :key="`tab-${social.value}`"
                                            :class="{
                                              'primary white--text': tabFollowUp == social.value
                                            }"
                                            class="py-1 pl-2 pr-2"
                                            style="
                                              border: 1px solid #eee;
                                              border-width: 1px 0px 1px 1px;
                                              border-top-left-radius: 5px;
                                              border-bottom-left-radius: 5px;
                                              cursor: pointer;
                                            "
                                            @click="tabFollowUp = social.value"
                                          >
                                            <span :class="social.icon"></span>
                                          </div>
                                        </template>
                                      </v-flex>
                                      <v-flex
                                        style="overflow: auto; min-height: 100px"
                                        class="ml-1"
                                      >
                                        <template
                                          v-for="social in conversationSocialChannelOptions"
                                        >
                                          <div
                                            v-show="tabFollowUp == social.value"
                                            :key="`message-${social.value}`"
                                          >
                                            <template
                                              v-if="
                                                multiFollowUpMessages[
                                                  `follow_up_${social.value}_messages`
                                                ] &&
                                                multiFollowUpMessages[
                                                  `follow_up_${social.value}_messages`
                                                ][0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="
                                                  multiFollowUpMessages[
                                                    `follow_up_${social.value}_messages`
                                                  ]
                                                "
                                                :channel="tabFollowUp"
                                              ></message-viewer>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </div>
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </template>
                                </div>
                              </template>
                            </template>
                            <div v-if="!isCommentToInbox">
                              <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                              <div class="quickreply">
                                <template v-if="follow_up_quick_reply.length > 0">
                                  <ul class="tags">
                                    <li
                                      v-for="(reply, index) in follow_up_quick_reply"
                                      :key="'follow_up_quick_reply' + index"
                                      class="tag"
                                    >
                                      {{ reply }}
                                    </li>
                                  </ul>
                                </template>
                                <template v-else>-</template>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div>
                        <v-divider></v-divider>

                        <v-tabs slider-color="primary" touchless show-arrows>
                          <v-tab
                            v-if="showAdvancedMenu('customer')"
                            :key="0"
                            :href="'#subtab-0'"
                            ripple
                            >{{ $t('Customer') }}</v-tab
                          >
                          <v-tab
                            v-if="!isCommentToInbox && showAdvancedMenu('context')"
                            :key="1"
                            :href="'#subtab-1'"
                            ripple
                            >{{ $t('Context') }}</v-tab
                          >
                          <v-tab
                            v-if="showAdvancedMenu('line_notify')"
                            :key="2"
                            :href="'#subtab-2'"
                            ripple
                            >{{ $t('Line Notify') }}</v-tab
                          >
                          <v-tab-item :key="0" :value="'subtab-0'">
                            <v-card flat>
                              <v-card-text>
                                <div>
                                  <div class="caption">{{ $t('Status') }}</div>
                                  <p class="primary-color">
                                    {{
                                      intent.follow_up_userstatus
                                        ? intent.follow_up_userstatus
                                        : '-'
                                    }}
                                  </p>
                                </div>
                                <div>
                                  <div class="caption">{{ $t('Tag') }}</div>
                                  <ul class="tags pt-1">
                                    <li
                                      v-for="(usertag, index) in follow_up_usertags"
                                      :key="'usertag_' + index"
                                      class="tag"
                                    >
                                      <specialtext :text="usertag"></specialtext>
                                    </li>
                                  </ul>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item v-if="!isCommentToInbox" :key="1" :value="'subtab-1'">
                            <v-card flat>
                              <v-card-text>
                                <v-layout>
                                  <v-flex>
                                    <div class="caption">Context Out</div>
                                    <p class="primary-color">
                                      {{
                                        intent.follow_up_context_out
                                          ? intent.follow_up_context_out
                                          : '-'
                                      }}
                                    </p>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item :key="2" :value="'subtab-2'">
                            <v-card flat>
                              <v-card-text>
                                <div class="caption">{{ $t('Line Notify') }}</div>
                                <div class="primary-color">
                                  {{
                                    intent.follow_up_linenoti_text
                                      ? intent.follow_up_linenoti_text
                                      : '-'
                                  }}
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs>
                      </div>
                    </template>
                  </div>
                </v-card-text>
              </v-card></v-tab-item
            >

            <v-tab-item :key="9" :value="'tab-9'">
              <v-card flat>
                <v-card-text>
                  <div>
                    <div class="caption">ผู้ทำรายการ</div>
                    <p class="primary-color">{{ intent.update_by || '-' }}</p>
                  </div>
                  <div>
                    <IntentHistoryVue :intent-id="intent.id" />
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="10" :value="'tab-10'">
              <ManageBotProfile :intent="intent" :type="'view'" />
            </v-tab-item>

            <v-tab-item :key="11" :value="'tab-11'">
              <RichMenu :value="intent.line_rich_menu_setting" />
            </v-tab-item>

            <v-tab-item :key="12" :value="'tab-12'">
              <PurchaseEventManagement :intent="intent" readonly />
            </v-tab-item>

            <v-tab-item :key="'user-status'" :value="'user-status'">
              <UserStatus :value="intent.user_states || undefined" />
            </v-tab-item>

            <v-tab-item :key="'event-tracking'" :value="'event-tracking'">
              <EventTracking :value="intent.event_tracking || undefined" />
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import specialtext from '@/components/elements/specialtext'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'
import IntentSelectPostLabel from './IntentSelectPostLabel'
import cloneDeep from 'lodash/cloneDeep'
import { PAGE, PAGE_GROUP } from '@/constants/page.js'
import AvailableMultipleChannel from './AvailableMultipleChannel'
import beaconApi from '@/api/beacon'

import PreviewConversation from '@/components/elements/Conversation/PreviewConversation'
import PreviewBeaconConversation from '@/components/elements/Conversation/PreviewBeaconConversation'
import { handleApiError, handleResponse } from '../../../api/util'
import dayjs from 'dayjs'
import AssetWiseRoleSelect from './AssetWiseRoleSelect.vue'
import IntentTicketGroup from './Ticket/IntentTicketGroup'
import IntentTicket3Group from './Ticket3/IntentTicketGroup'
import IntentHistoryVue from './IntentHistory.vue'
import ManageBotProfile from '@/components/elements/BotProfile/ManageBotProfile'
import IntentSlipVerificationPreview from './IntentSlipVerificationPreview.vue'
import IntentScheduleTable from './IntentScheduleTable.vue'
import PurchaseEventManagement from './PurchaseEventManagement.vue'
import RichMenu from './RichMenu'
import UserStatus from './UserStatus'
import EventTracking from './EventTracking'
import { FEATURE } from '@/constants/feature'

import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

const dayItems = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const day = dayjs().day()
const dayMatch = dayItems[day === 0 ? dayItems.length : day - 1]
const today = dayjs().format('YYYY-MM-DD')
const dayAbb = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun'
}

export default {
  components: {
    'manage-intent': manageIntent,
    specialtext,
    MessageViewer,
    ToggleButton,
    IntentSelectPostLabel,
    PreviewConversation,
    AvailableMultipleChannel,
    PreviewBeaconConversation,
    AssetWiseRoleSelect,
    IntentTicketGroup,
    IntentTicket3Group,
    IntentHistoryVue,
    ManageBotProfile,
    IntentSlipVerificationPreview,
    IntentScheduleTable,
    PurchaseEventManagement,
    RichMenu,
    UserStatus,
    EventTracking
  },
  props: {
    value: {
      type: null,
      default: null
    },
    excludedIntentName: {
      default: '',
      type: String
    },
    isCommentToInbox: {
      default: null
    },
    filterIntents: {
      default: null
    },
    isLiveStream: {
      default: null
    },
    livechat: {
      default: false,
      type: Boolean
    },
    hideCopy: {
      default: false,
      type: Boolean
    },
    hideDelete: {
      default: false,
      type: Boolean
    },
    hideQuestion: {
      default: false,
      type: Boolean
    },
    hideAdvanceOptions: {
      default: null
    },
    hideSetting: {
      default: false,
      type: Boolean
    },
    hidePriority: {
      default: false,
      type: Boolean
    },
    readonlyName: {
      default: false,
      type: Boolean
    },
    availableBubbles: {},
    hideChoice: {
      default: false,
      type: Boolean
    },
    hideStatus: {
      default: false,
      type: Boolean
    },
    isBeacon: {},
    isIntent: {},
    isFirstAnnouncement: {
      default: false,
      type: Boolean
    }
  },

  data: function () {
    return {
      dataVerifySlip: [],
      isEdit: false,
      intent: this.value,
      // showDetail: false,
      showPreview: false,
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],
      isOtherLang: false,
      advancedTab: null,
      showMultipleChannel: false,
      tab: 'fb',
      tabFollowUp: 'all',
      follow_up_quick_reply: [],
      follow_up_val: [],
      follow_up_within_seconds: [],
      showMultipleChannelFollowUp: false,
      isMetaVerifySlip: false
    }
  },
  computed: {
    specificBeaconIds() {
      if (this.intent.specific_beacon_ids) {
        return this.intent.specific_beacon_ids.split(',')
      }
      return []
    },
    beaconType() {
      let type = null
      if (this.intent.q_val.includes('beacon_enter')) {
        type = 'Beacon Enter'
      } else if (this.intent.q_val.includes('beacon_banner')) {
        type = 'Beacon Banner'
      } else {
        type = this.intent.q_val
      }
      return type
    },
    showIntentGroup() {
      return (
        (!this.isCommentToInbox &&
          this.$store.getters.showIntentGroup &&
          this.showAdvancedMenu('intent_group')) ||
        (this.isCommentToInbox &&
          [...this.$store.state.oceanlifePage, ...this.$store.state.rabbitReplyFBPostPage].includes(
            this.selectedBot.pageid
          )) ||
        (this.selectedBot && this.selectedBot.unlock_ticket_3)
      )
    },
    moment() {
      return moment
    },
    follow_up_usertags: function () {
      const vm = this
      if (vm.intent.follow_up_usertags !== '' && vm.intent.follow_up_usertags != null) {
        let usertags = vm.intent.follow_up_usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    ticket2showdelete() {
      return !this.livechat || this.intent.q_val === 'exacts(intent_type_quick_message)'
    },
    kfcpagemustedit() {
      if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
        if (this.intent.intentname.startsWith('t1') || this.intent.intentname.startsWith('s1')) {
          return false
        } else return true
      } else return true
    },
    intentgroup() {
      if (this.intent.intentgroup) {
        if (
          [
            'ticket',
            'ticket2',
            'studio7',
            'ustore',
            'tdtawandang',
            'cityfresh',
            ...this.$store.state.ticketThemeList
          ].includes(this.selectedBot.theme) ||
          [...this.$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
            this.selectedBot.pageid
          ) ||
          ['gpf'].includes(this.selectedBot.type) ||
          (this.selectedBot && this.selectedBot.unlock_ticket_3)
        ) {
          try {
            if (typeof this.intent.intentgroup === 'string') {
              return JSON.parse(this.intent.intentgroup)
            } else {
              return this.intent.intentgroup
            }
          } catch (error) {
            console.error(error)
            return this.intent.intentgroup
          }
        } else {
          return this.intent.intentgroup
        }
      } else {
        return '-'
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    }),
    intentStatus() {
      let vm = this
      let starttime = vm.intent.starttime
        ? vm.intent.onlytime && !this.isFirstAnnouncement
          ? moment().format('YYYY-MM-DD') + ' ' + moment(vm.intent.starttime).format('HH:mm')
          : vm.intent.starttime
        : null
      let endtime = vm.intent.endtime
        ? vm.intent.onlytime && !this.isFirstAnnouncement
          ? moment().format('YYYY-MM-DD') + ' ' + moment(vm.intent.endtime).format('HH:mm')
          : vm.intent.endtime
        : null

      var isOnline = false
      var isStarttime = false
      var isEndtime = false
      let intentstatus = null
      if (this.isBeacon) {
        intentstatus = this.intent.status
      } else {
        intentstatus = this.intent.intentstatus
      }

      if (endtime == null && starttime == null) {
        isOnline = intentstatus
      } else if (starttime == null && moment() < moment(endtime)) {
        isOnline = intentstatus
        isEndtime = true
      } else if (endtime == null && moment() > moment(starttime)) {
        isOnline = intentstatus
        isStarttime = true
      } else if (moment(endtime) < moment(starttime)) {
        isOnline = intentstatus && (moment() >= moment(starttime) || moment() <= moment(endtime))
        isStarttime = isEndtime = moment() >= moment(starttime) || moment() <= moment(endtime)
      } else {
        isOnline = intentstatus && moment().isBetween(starttime, endtime)
        isStarttime = isEndtime = moment().isBetween(starttime, endtime)
      }

      return {
        isOnline: isOnline,
        isStarttime: isStarttime,
        isEndtime: isEndtime
      }
    },
    timeSetting() {
      if (this.intent.onlytime === null && this.intent.time_setting) {
        let days = []
        for (const key of Object.keys(this.intent.time_setting)) {
          const timeSettingInfo = this.intent.time_setting[key]

          const open = !timeSettingInfo.openat
            ? '00:00'
            : dayjs(`${today}T${timeSettingInfo.openat.slice(0, 5)}:00`).format('HH:mm')

          const close =
            !timeSettingInfo.closeat || timeSettingInfo.closeat.slice(0, 5) === '24:00'
              ? '24:00'
              : dayjs(`${today}T${timeSettingInfo.closeat.slice(0, 5)}:00`).format('HH:mm')

          let start = null
          let end = null

          start = timeSettingInfo.openat
            ? today +
              ' ' +
              dayjs(`${today}T${timeSettingInfo.openat.slice(0, 5)}:00`).format('HH:mm')
            : today + ' ' + dayjs(`${today}T00:00:00`).format('HH:mm')

          end =
            timeSettingInfo.closeat && timeSettingInfo.closeat.slice(0, 5) !== '24:00'
              ? today +
                ' ' +
                dayjs(`${today}T${timeSettingInfo.closeat.slice(0, 5)}:00`).format('HH:mm')
              : today + ' ' + dayjs(`${today}T23:59:59`).format('HH:mm')

          const inTime =
            (!timeSettingInfo.closeat && !timeSettingInfo.openat) ||
            (start && end && dayjs().isBetween(dayjs(start), dayjs(end)))

          days.push({
            ...timeSettingInfo,
            isToday: dayMatch === key,
            isActive: dayMatch === key && timeSettingInfo.status && inTime,
            day: this.$t(dayAbb[key]),
            timeLength: `${open} - ${close}`
          })
        }
        return days
      } else {
        return []
      }
    },
    questions: function () {
      if (this.intent.q_val !== '') {
        return this.intent.q_val.split(',')
      } else {
        return ''
      }
    },
    answers: function () {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.a_val, vm.intent.a_type)
      } catch (error) {
        return [[]]
      }
    },
    fb_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    line_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ig_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ms_team_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.ms_team_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    whatsapp_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.whatsapp_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    app_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.app_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    webchat_answers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.webchat_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    replies: function () {
      var vm = this
      if (vm.intent.quick_reply !== '' && vm.intent.quick_reply != null) {
        var replies = vm.intent.quick_reply.split(',')
        return replies
      } else {
        return []
      }
    },
    usertags: function () {
      var vm = this
      if (vm.intent.usertags !== '' && vm.intent.usertags != null) {
        var usertags = vm.intent.usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    deleteUserTags: function () {
      var vm = this
      if (vm.intent.user_tags_delete !== '' && vm.intent.user_tags_delete != null) {
        const user_tags_delete = vm.intent.user_tags_delete.split(',')
        return user_tags_delete
      } else {
        return []
      }
    },
    postidlist: function () {
      var vm = this
      var includes = []
      var excludes = []
      var post_keywords = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      if (vm.intent.post_keywords && vm.intent.post_keywords != '') {
        try {
          post_keywords = JSON.parse(vm.intent.post_keywords)
        } catch (error) {
          post_keywords = vm.intent.post_keywords.split(',')
        }
      }
      return { includes: includes, excludes: excludes, post_keywords: post_keywords }
    },
    showDetail: function () {
      if (!this.isEdit) {
        return this.intent.isShow
      } else {
        return true
      }
    },
    answersFollowUp: function () {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_val, vm.intent.follow_up_type)
      } catch (error) {
        return [[]]
      }
    },
    multiFollowUpMessages() {
      const multipleMessages = this.conversationSocialChannelOptions.reduce((prev, curr) => {
        let messages = [[]]
        try {
          messages = this.formatAnswer(this.intent[`follow_up_${curr.value}_val`], 'json')
        } catch (error) {
          console.error(error)
        }
        prev[`follow_up_${curr.value}_messages`] = messages
        return prev
      }, {})
      return multipleMessages
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData
    },
    isJuzmatchSale() {
      return PAGE.JUZMATCH_SALE.includes(this.selectedBot.pageid)
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    roleJuzMatchMasterData() {
      if (this.isJuzmatchCrm) {
        return this.$store.state.juzMatchMasterDataCrm || []
      } else {
        return this.$store.state.juzMatchMasterDataSale || []
      }
    },
    role() {
      let current = this.roleJuzMatchMasterData.find(
        (el) => el.id === this.intent.intent_member_type
      )
      if (current && current.name) {
        return current.name
      } else {
        return null
      }
    },
    isRoots() {
      return PAGE.ROOTS.includes(this.selectedBot.pageid)
    },
    rootsCompanyMasterData() {
      return this.$store.state.rootsMasterData.company
    },
    rootsCurrentCompany() {
      let company = ''
      if (this.intent.roots_company_id) {
        company = this.rootsCompanyMasterData.find((el) => {
          return el.id === this.intent.roots_company_id
        })
      }
      return company ? `${company.company_code} - ${company.company_name}` : '-'
    },
    isAssetWise() {
      return ['assetwise'].includes(this.selectedBot.theme)
    },
    hasSocialConnected() {
      return (
        this.selectedBot.page_access_token ||
        this.selectedBot.line_modular_botid ||
        this.selectedBot.line_access_token
      )
    },
    isRefLinkEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.REF_LINK)
    },
    isRichMenuEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.LINE_RICH_MENU)
    },
    isSrichand() {
      return this.selectedBot.page_group === PAGE_GROUP.SRICHAND
    },
    isEventTrackingEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.EVENT_TRACKING)
    }
  },
  watch: {
    value: function (newVal) {
      this.intent = newVal

      const key =
        this.tabFollowUp !== 'all'
          ? `follow_up_${this.tabFollowUp}_quick_reply`
          : 'follow_up_quick_reply'
      this.follow_up_quick_reply = this.intent[key] ? this.intent[key].split(',') : []
    },
    'intent.q_val': function () {
      this.formatData(this.intent.q_val)
      this.showMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`) &&
          this.intent[`${social.value}_val`]
        )
      })
    },
    intent: function (newVal) {
      this.$emit('onUpdate', newVal)
    },
    tabFollowUp: {
      immediate: true,
      handler(value) {
        const key = value !== 'all' ? `follow_up_${value}_quick_reply` : 'follow_up_quick_reply'
        this.follow_up_quick_reply = this.intent[key] ? this.intent[key].split(',') : []
      }
    }
  },
  mounted: function () {
    if (this.intent) {
      this.formatData(this.intent.q_val)
      this.handleMultiChannel()
      this.handleMultiFollowUpChannel()
    }
  },
  methods: {
    getBankName(bankName) {
      const vm = this
      let bankAlltype = vm.$store.state.bankForVerify.concat(vm.$store.state.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.$store.state.paymentGateway)
      return bankAlltype.filter((bankInfo) => bankInfo.value === bankName)[0]
    },
    showAdvancedMenu(type) {
      if (this.hideAdvanceOptions) {
        return !this.hideAdvanceOptions.includes(type)
      } else {
        return true
      }
    },
    async onChangeIntentStatus() {
      let intentstatus = null
      if (this.intent.intentname === '{first_announcement_message}' && !this.intent.id) {
        this.intent.intentstatus = !this.intent.intentstatus
        return
      } else if (this.isBeacon) {
        intentstatus = this.intent.status ? this.intent.status : false
        this.$set(this.intent, 'status', !intentstatus)
      } else {
        intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
        this.$set(this.intent, 'intentstatus', !intentstatus)
      }

      let data = {
        ...this.intent
      }
      var vm = this
      vm.$store.dispatch('loading')

      if (this.isBeacon) {
        const response = await vm.updateIntentBeacon(data)

        if (response && response.status === 200) {
          vm.$store.dispatch('loading')
          return true
        }
      } else {
        api
          .editIntent(data, function (error) {
            if (error) {
              console.error(error)
              vm.$store.dispatch('loading')
              return
            }
            vm.$store.dispatch('loading')
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    editIntent() {
      this.isEdit = true
      this.$store.commit('ADD_EDITTING_INTENT', this.intent.id)
    },
    async updateIntentBeacon(data) {
      const vm = this
      try {
        let tempData = data
        if (tempData.onlytime) {
          tempData = {
            ...tempData,
            start_date: null,
            end_date: null
          }
        } else {
          tempData = {
            ...tempData,
            start_time: null,
            end_time: null
          }
        }
        vm.$store.dispatch('loading')
        const response = await beaconApi.putUpdateIntentBeacon({ data: tempData })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
        return null
      }
    },
    sendToLivechat(intent) {
      this.$emit('sendToLivechat', intent)
    },
    handleMultiFollowUpChannel() {
      const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`) &&
          this.intent[`follow_up_${social.value}_val`] &&
          String(this.intent[`follow_up_${social.value}_val`]) !== 'null'
        )
      })

      this.showMultipleChannelFollowUp = !!hasMultipleChannel

      if (this.showMultipleChannelFollowUp) {
        try {
          this.tabFollowUp = hasMultipleChannel.value
          this.channels = this.conversationSocialChannelOptions
            .map((social) => {
              if (
                this.multiFollowUpMessages[`follow_up_${social.type}.messages`].length > 0 &&
                this.multiFollowUpMessages[`follow_up_${social.type}.messages`].length > 0
              ) {
                return social.type
              } else {
                return null
              }
            })
            .filter((social) => social)
        } catch (error) {
          this.tab = 'fb'
        }
      }
    },
    handleMultiChannel() {
      const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`) &&
          this.intent[`${social.value}_val`]
        )
      })

      this.showMultipleChannel = hasMultipleChannel ? hasMultipleChannel : false
    },

    onSave: function () {
      this.handleMultiChannel()
      this.handleMultiFollowUpChannel()
      this.isEdit = false
      this.$store.commit('REMOVE_EDITTING_INTENT', this.intent.id)
    },
    onClose: function () {
      this.isEdit = false
      this.$store.commit('REMOVE_EDITTING_INTENT', this.intent.id)
    },
    toggleDetail: function () {
      this.intent.isShow = !this.intent.isShow
    },
    onCopyMyIntent: function () {
      const vm = this
      let data = {
        ...cloneDeep(vm.intent)
      }
      data.pageid = vm.selectedBot.pageid

      if (vm.isBeacon) {
        data.campaign_name = data.campaign_name + '_' + moment().format('x')
      } else {
        data.intentname = data.intentname + '_' + moment().format('x')
        // eslint-disable-next-line no-irregular-whitespace
        data.a_val = data.a_val.replace(/ /gim, ' ')
      }

      vm.$emit('onCopyIntent', {
        onCopy: function () {
          return new Promise((resolve, reject) => {
            vm.$swal
              .fire({
                title: vm.$t('Do you want to copy {name}?', {
                  name: vm.isBeacon
                    ? // eslint-disable-next-line no-useless-escape
                      vm.intent.campaign_name.replace(/\<|\>/g, '')
                    : // eslint-disable-next-line no-useless-escape
                      vm.intent.intentname.replace(/\<|\>/g, '')
                }),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
              .then(async (result) => {
                if (result.value) {
                  if (vm.isBeacon) {
                    try {
                      vm.$store.dispatch('loading')
                      const response = await vm.addIntentBeacon(data)
                      vm.$store.dispatch('loading')
                      handleResponse(response)

                      if (response && response.status === 200) {
                        const tempData = response.data.result
                        data.id = tempData.id
                        resolve(data)
                      }
                    } catch (error) {
                      vm.$store.dispatch('loading')
                      handleApiError(error)
                      reject()
                    }
                  } else {
                    vm.$store.dispatch('loading')
                    api.addIntent(data, function (error, response) {
                      if (error) {
                        console.error(error)
                        vm.$store.dispatch('loading')
                        reject()
                      }
                      data.id = response.id
                      resolve(data)
                      vm.$store.dispatch('loading')
                    })
                  }
                }
              })
          })
        }
      })
    },
    async addIntentBeacon(data) {
      const vm = this
      try {
        let tempData = data
        if (tempData.onlytime) {
          tempData = {
            ...tempData,
            start_date: null,
            end_date: null
          }
        } else {
          tempData = {
            ...tempData,
            start_time: null,
            end_time: null
          }
        }
        vm.$store.dispatch('loading')
        const response = await beaconApi.postAddIntentBeacon({ data: tempData })
        vm.$store.dispatch('loading')
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        if (error.result === 'DUPLICATE_INTENT_NAME') {
          vm.$swal({
            title: vm.$t('Error'),
            type: 'error',
            text: vm.$t('duplicate_conversation_name'),
            confirmButtonText: vm.$t('Confirm')
          })
        }
        console.error(error)
        vm.$store.dispatch('loading')

        return null
      }
    },
    formatData: function (text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      var isPremium = vm.$store.getters.getPackage === 'premium'
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.forEach(function (question) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({
              text: keyword.trim(),
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else {
            vm.normal.push({ text: question, checkLang: vm.isSupportLanguage(question, isPremium) })
            if (!vm.isSupportLanguage(question, isPremium)) {
              vm.isOtherLang = true
            }
          }
        })
        vm.dataVerifySlip = []
        if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
          try {
            const textSplitValue = vm.normal[0].text.split('{verify_slip.bank_info=')
            const textSplitValue2 = textSplitValue[1].split(',')
            const dataValue = textSplitValue2[0].split('^')
            dataValue[dataValue.length - 1] = dataValue[dataValue.length - 1].split('}')[0]
            dataValue.map((item, index) => {
              let typeAccount = null
              if (item.split('|')[0] === 'promptpay') {
                typeAccount = { value: 'promptpay', label: 'Promptpay' }
              } else if (item.split('|')[0].includes('ew')) {
                typeAccount = { value: 'eWallet', label: 'E-Wallet' }
              } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
                typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
              } else {
                typeAccount = { value: 'transfer', label: 'Transfer' }
              }
              let keyword = []
              if (item.split('|') && item.split('|')[2]) {
                item
                  .split('|')[2]
                  .split('!')
                  .forEach((element) => {
                    keyword.push({ text: element })
                  })
              }
              vm.dataVerifySlip.push({
                id: `${dayjs().format('x')}_${index}`,
                typeAccount: typeAccount,
                bankAccountNo: item.split('|')[1],
                bankName: item.split('|')[0],
                keyword: keyword
              })
            })
          } catch (error) {
            console.error(error)
          }
        } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.image}')) {
          vm.dataVerifySlip[0] = {
            id: dayjs().format('x'),
            typeAccount: { value: 'all', label: 'All' },
            bankAccountNo: '',
            bankName: ''
          }
        } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{meta_pay_verified}')) {
          vm.isMetaVerifySlip = true
          vm.dataVerifySlip = vm.$store.state.metaVerifySlip
        }
      }
    },
    formatAnswer(a_val, a_type) {
      return this.parseConversation(
        { a_val, a_type },
        {
          isCommentToInbox: this.isCommentToInbox,
          isLiveStream: this.isLiveStream
        }
      )
    },
    handleGetTextGpfBuddyMasterData(type, intent) {
      const gpfBuddyMasterData = this.gpfBuddyMasterData
      const selectedCompany = intent.gpf_company_code
      const selectedGroup = intent.gpf_group_code
      const selectedDepartment = intent.gpf_department_code
      const selectedPosition = intent.gpf_position_code

      let text = ''

      if (type && gpfBuddyMasterData && selectedCompany) {
        let tempCompanyData = null
        let tempGroupData = null
        let tempDepartmentData = null
        let tempPositionData = null

        tempCompanyData = gpfBuddyMasterData.find((el) => {
          return el.company_code === selectedCompany
        })

        if (selectedCompany && selectedGroup) {
          tempGroupData = tempCompanyData.groups.find((el) => {
            return el.group_code === selectedGroup
          })
        }

        if (selectedCompany && selectedGroup && selectedDepartment) {
          tempDepartmentData = tempGroupData.departments.find((el) => {
            return el.department_code === selectedDepartment
          })
        }

        if (selectedCompany && selectedGroup && selectedDepartment && selectedPosition) {
          tempPositionData = tempDepartmentData.positions.find((el) => {
            return el.position_code === selectedPosition
          })
        }

        switch (type) {
          case 'company':
            text = tempCompanyData ? tempCompanyData.company_name : '-'
            break
          case 'group':
            text = tempGroupData ? tempGroupData.group_name : '-'
            break
          case 'department':
            text = tempDepartmentData ? tempDepartmentData.department_name : '-'
            break
          case 'position':
            text = tempPositionData ? tempPositionData.position_name : '-'
            break

          default:
            break
        }
      }

      return text
    },
    toTransformedSchedule({ time_setting }) {
      if (!time_setting) return []
      return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
        .map((dow) => [dow, time_setting[dow]])
        .filter(([, { status }]) => status)
        .map(([dow, { openat, closeat }]) => ({
          dow,
          start: openat.replace(/(\d+:\d+).*/, '$1'),
          end: closeat.replace(/(\d+:\d+).*/, '$1')
        }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/intent-item.vue